// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const Close: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M14.113 12l6.444-6.429a1.504 1.504 0 10-2.128-2.128L12 9.887 5.571 3.443a1.504 1.504 0 10-2.128 2.128L9.887 12l-6.444 6.429a1.498 1.498 0 00-.009 2.119l.009.009a1.498 1.498 0 002.119.009l.009-.009L12 14.113l6.429 6.444a1.498 1.498 0 002.119.009l.009-.009a1.498 1.498 0 00.009-2.119l-.009-.009L14.113 12z"
            />
        </svg>
    );
};

export const CloseOffset: IconOffset = {
    vertical: 11,
    horizontal: 11,
};

export default React.memo(Close);
